import { SurveyAnswers } from "./surveyTypes";

// Field names the legacy widget submitted for every survey of a kind (not the item name).
const LEGACY_SPECIAL_NAMES = ["priority", "reportedBy"];

/**
 * A migrated survey's answers keyed by the field names its legacy form used
 * (`legacyKeyMap`: legacy name → block key, from GET /surveys/:id), so host
 * callbacks (Gleap.on("outbound-sent"/"feedback-sent"), native feedbackSent)
 * and the tracked `outbound-<id>-submitted` event keep the keys customer code
 * reads. Surveys created in 2.0 (no map) keep their block keys.
 */
export const legacyFormDataOf = (
  answers: SurveyAnswers,
  legacyKeyMap?: Record<string, string> | null,
): SurveyAnswers => {
  if (!legacyKeyMap || typeof legacyKeyMap !== "object") return answers;
  const nameOf: Record<string, string> = {};
  for (const [name, key] of Object.entries(legacyKeyMap)) {
    if (typeof key !== "string") continue;
    if (!nameOf[key] || LEGACY_SPECIAL_NAMES.includes(name)) nameOf[key] = name;
  }
  const formData: SurveyAnswers = {};
  for (const [key, value] of Object.entries(answers ?? {})) {
    formData[nameOf[key] ?? key] = value;
  }
  return formData;
};
